import React, { useEffect } from 'react';

import {
  sendEmailVerificationEvent,
} from '@kueski-analytics/events/email_verification';

import { isEmbeddedAmazon } from 'Utils/mobile';
import { getApplicationInformation } from 'Redesign_Funnel/utils/getApplicationInformation';
import useMerchantPaymentQuery from 'Src/hooks/useMerchantPaymentQuery';
import useProtectedApplication from 'Src/hooks/useProtectedApplication';
import { useLocalStorage } from 'Hooks/useStorage';

import { EMAIL_VERIFICATION_STATUS, EMAIL_VERIFICATION_STATUS_VERIFIED } from '../EmailVerification.constants';
import { SuccessVerificationUI } from '../components/SuccessVerificationUI';

const SuccessEmailVerification = () => {
  const isEmbeddedAmzApp = isEmbeddedAmazon();
  const { applicationProcessId, customerId, productType } = getApplicationInformation();
  const { data, isLoading: isLoadingApplication } = useProtectedApplication();
  const { data: paymentData, isLoading: isLoadingPayment } = useMerchantPaymentQuery();
  const [, setEmailVerificationStorage] = useLocalStorage(EMAIL_VERIFICATION_STATUS);

  const sendEmailVerificationSuccessEvent = () => {
    const eventData = {
      application_id: applicationProcessId,
      is_embedded_amz: isEmbeddedAmzApp,
      kueski_user_id: customerId,
      merchant_id: paymentData?.payment?.merchantId,
      merchant_name: paymentData?.payment?.merchantName,
      page_name: 'email_verified',
      product_type: productType,
      purchase_amount: paymentData?.payment?.amount,
      recurrent: data?.recurrent,
    };
    sendEmailVerificationEvent(eventData);
  };

  useEffect(() => {
    if (isLoadingApplication || isLoadingPayment) return;
    sendEmailVerificationSuccessEvent();
  }, [isLoadingApplication, isLoadingPayment]);

  useEffect(() => {
    setEmailVerificationStorage(EMAIL_VERIFICATION_STATUS_VERIFIED);
  }, []);

  return <SuccessVerificationUI />;
};

export default SuccessEmailVerification;
